import React, { memo } from 'react';
import LazyImage from '../../CustomLibraries/LazyImage';
import DoctorsSectionForCard from '../../DoctorSectionForCard/DoctorsSectionForCard';
import { ClockCircleOutline, FiShare2, IoLayersOutline, MdOutlineArrowRightAlt } from '../../icons';
import './css/_courseCardV2.scss';
import useRedirect from '../../customHooks/useRedirect';
import ShareCard from '../../ShareCard';
import { colorDecider, parseDuration } from '../../../pages/grTraining/utils/utilities';
import { reactHtmlParser } from '../../../common/common';

function CourseCardV2({
  gtmTagVariable = '',
  id,
  title,
  image,
  url,
  module_count,
  duration,
  is_completed,
  specialities_ids_and_names
}) {
  const { redirectTo } = useRedirect();
  const click = () => redirectTo('TrainingCover', id, title);
  const specialityClick = () => {
    if (specialities_ids_and_names?.length > 0) {
      let { id, name } = specialities_ids_and_names[0];
      redirectTo('Speciality', id, name);
    }
  };
  return (
    <div className="w-100 courseCardV2Box bg-white shadow rounded-3 position-relative overflow-hidden">
      <div className="cardV2Pic position-relative">
        {image && (
          <LazyImage
            src={image}
            alt="image"
            className={`object-fit-cover w-100 h-100 float-start ${gtmTagVariable}_courseCardV2`}
            onClick={click}
          />
        )}
        <div className={`overlay bg-black bg-opacity-25 ${gtmTagVariable}_courseCardV2`}></div>
        <div className="shareBtn d-flex align-items-center justify-content-center position-absolute bg-white bg-opacity-75 z-2 rounded">
          <ShareCard
            customClass={`fs-2 text-black  ${gtmTagVariable}_courseCardV2_share`}
            data={{ title, url }}
          />
        </div>
        <div className="courseProgress rounded bg-white d-flex align-items-center position-absolute bottom-0 z-2 py-2 px-3">
          <div
            className="circleProgress d-inline-block me-3 position-relative overflow-hidden rounded-circle"
            style={{ backgroundColor: colorDecider(is_completed) }}
          >
            <div
              className="circleProgressIn position-absolute start-50 w-100 h-100 bg-white bg-opacity-75"
              style={{
                top: `-${
                  is_completed > 100 ? 100 : is_completed > 0 ? Math.round(is_completed) : 0 ?? 0
                }%`
              }}
            ></div>
            <div
              className="circleProgressIn2 position-absolute start-50 w-100 h-100 bg-white bg-opacity-25 mt-1"
              style={{
                top: `-${
                  is_completed > 100 ? 100 : is_completed > 0 ? Math.round(is_completed) : 0 ?? 0
                }%`
              }}
            ></div>
          </div>
          <span className="fs-5 fw-medium" style={{ color: colorDecider(is_completed) }}>
            {is_completed > 100 ? 100 : is_completed > 0 ? Math.round(is_completed) : 0}% Completed
          </span>
        </div>
      </div>
      <div className="w-100 text-start cardV2Body p-3 p-md-4">
        {specialities_ids_and_names?.length > 0 && (
          <h6
            className={`fs-4 fw-normal text-dark speciality mb-2 cursorPointer ${gtmTagVariable}_courseCardV2_speciality`}
            onClick={specialityClick}
          >
            {specialities_ids_and_names[0]?.name}
          </h6>
        )}
        <h4
          className={`fs-16 fw-medium text-black line-clamp-2 mb-4 ${gtmTagVariable}_courseCardV2`}
          onClick={click}
        >
          {reactHtmlParser(title)}
        </h4>
        <div className="w-100 cardV1Ftr d-flex align-items-center justify-content-between">
          <ul className="cardV2Statistics text-black fs-4 ps-0 pe-3 mb-0 list-unstyled list-inline flex-1">
            {module_count && (
              <li className="list-inline-item d-inline-flex gap-2 me-3">
                <IoLayersOutline customClass="fs-3 text-black" /> {module_count} Modules
              </li>
            )}
            {duration && (
              <li className="list-inline-item d-inline-flex gap-2">
                <ClockCircleOutline customClass="fs-3 text-black" />{' '}
                {parseDuration(duration).duration} {parseDuration(duration).unit}
              </li>
            )}
          </ul>
          <div
            className="cardV1FtrBtn rippleEffect rounded cursorPointer position-relative overflow-hidden d-inline-block p-3 fs-4"
            onClick={click}
          >
            <div
              className="cardV1BtnHover position-absolute top-50 start-50 translate-middle"
              style={{ backgroundColor: '#355FD3' }}
            ></div>
            <div
              className="cardV1BtnBorder rounded position-absolute top-50 start-0 translate-middle-y"
              style={{ borderColor: '#355FD3' }}
            ></div>
            <span
              className={`position-relative z-1 d-flex ${gtmTagVariable}_courseCardV2`}
              style={{ color: '#355FD3' }}
            >
              View Course{' '}
              <MdOutlineArrowRightAlt
                style={{ color: '#355FD3' }}
                customClass={`fs-2 ms-2 ${gtmTagVariable}_courseCardV2_view_course_icon`}
                gtmTagVariable={`${gtmTagVariable}_courseCardV2`}
              />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
export default memo(CourseCardV2);
